import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';


@Injectable({
  providedIn: 'root'
})
export class AssetsService {

  constructor(private http: HttpClient) { }

  public token = '';

  // getorcfusioncode(oracleCode: any) {
  //   const headers = new HttpHeaders({
  //     'Authorization': `${this.token}`
  //   });
  //   return this.http.get(environment.orgUrl + "/jwtV2/api/captureGeolocation/getBuildingDetailsByOrcFusionCode?orcFusionBuildingCode=" + oracleCode, { headers })
  // }

  getCampuslisttable() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/campusWiseAssets', { headers })
  }

  orafusion(searchorg: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get<any>(environment.employeeURL + '/jwtV2/api/common/buildingDetailsByFusionCode?orcFusionBuildingCode=' + searchorg, { headers });
  }

  getmajor() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/majorCategoryList', { headers })
  }

  getminor(major: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/minorCategoryList?majorCatId=' + major, { headers })
  }
  getorganization(fusionCode: any, orgType: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/allOrganizationList?fusionBuildingCodeProd=' + fusionCode + '&' + 'orgType=' + orgType, { headers })
  }

  getblock() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/apiV2/assetTracking/ListDetails', { headers })
  }
  assetssave(payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.orgUrl + '/apiV2/assetTracking/saveAssetDetails', payload, { headers })
  }


  gettabledata(tablelist: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/jwtV2/api/assetTracking/assetDetails?orcFusionBuildingCode=' + tablelist, { headers })
  }

  getapprovalist(details: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/jwtV2/api/assetTracking/assetsApprovalStatus?filterBy=' + details, { headers })
  }

  postapproval(approved: any, payload: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.post(environment.orgUrl + '/jwtV2/api/assetTracking/saveAssetApprovalDetails?entityQRId=' + approved, payload, { headers })
  }

  //Generate screen //

  getgeneratestate() {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/jwtV2/api/common/employeeStates', { headers })
  }

  getgeneratecity(stateId: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/jwtV2/api/common/emplStateCities?stateId=' + stateId, { headers })
  }

  getgeneratecampus(cityid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/jwtV2/api/common/empCityCampuses?cityId=' + cityid, { headers })
  }

  getgeneratebuilding(campusid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/jwtV2/api/common/empCmpBuilding?campusId=' + campusid, { headers })
  }

  getgeneratetable(bidid: any) {
    const headers = new HttpHeaders({
      'Authorization': `${this.token}`
    });
    return this.http.get(environment.orgUrl + '/jwtV2/api/common/approvedAssetList?buildingId=' + bidid, { headers })
  }

}


